import $ from 'jquery';

export default async () => {
    await Promise.resolve($.getScript('/commJS/moment-timezone.min.js'));
    return window.moment;
};